import { useState, useEffect } from 'react';
import Header from "../components/header2";
import Form from '../components/form';

const PrenatalProgram = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  const [spotsLeft, setSpotsLeft] = useState('10');
  const [mainVideoUrl, setMainVideoUrl] = useState('');
  const [testimonialVideo1, setTestimonialVideo1] = useState('');
  const [testimonialVideo2, setTestimonialVideo2] = useState('');
  const [testimonialVideo3, setTestimonialVideo3] = useState('');
  const [prenatalDay, setPrenatalDay] = useState(0);
  const [prenatalHours, setPrenatalHours] = useState(0);
  const [prenatalMinutes, setPrenatalMinutes] = useState(0);
  const [wholeDate, setWholeDate] = useState(null);

  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiUrl = `https://www.aos.fit/api/getalldata`;
        let allData = await fetch(apiUrl);
        const allDataResult = await allData.json();

        setSpotsLeft(allDataResult['prenatalSpot'] || '10');
        // Remove autoplay from video URLs
        setMainVideoUrl((allDataResult['prenatalMainVideo'] || '').replace('?autoplay=1&enablejsapi=1', ''));
        setTestimonialVideo1((allDataResult['prenatalTestimonialVideo1'] || '').replace('?autoplay=1&enablejsapi=1', ''));
        setTestimonialVideo2((allDataResult['prenatalTestimonialVideo2'] || '').replace('?autoplay=1&enablejsapi=1', ''));
        setTestimonialVideo3((allDataResult['prenatalTestimonialVideo3'] || '').replace('?autoplay=1&enablejsapi=1', ''));

        // Set countdown values from API
        setPrenatalDay(allDataResult['prenatalDay'] || 0);
        setPrenatalHours(allDataResult['prenatalHour'] || 0);
        setPrenatalMinutes(allDataResult['prenatalMinute'] || 0);
        setWholeDate(allDataResult['prenatalTimestamp'] || null);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  // Countdown timer logic using timestamp
  useEffect(() => {
    if (!wholeDate) return;

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = wholeDate - now;

      if (distance < 0) {
        clearInterval(timer);
        setTimeLeft({
          days: prenatalDay,
          hours: prenatalHours,
          minutes: prenatalMinutes,
          seconds: 0
        });
      } else {
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        setTimeLeft({
          days,
          hours,
          minutes,
          seconds
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [wholeDate, prenatalDay, prenatalHours, prenatalMinutes]);

  const formatNumber = (num) => {
    return num < 10 ? `0${num}` : num;
  };

  return (
    <>
      <div className="prenatal-container">
        <Header />

        {/* Hero Section */}
        <div className="hero-section">
          <div className="hero-content">
            <h1 className="hero-title">
              <span className="title-line2">ATTENTION NEW & EXPECTING MOMS:</span>
              <span className="title-line2">You Don't Have To Live With The Aches, Extra</span>
              <span className="title-line2">Weight, And Feeling "Heavy" Every Time You Move.</span>
            </h1>

            <div className="hero-subtitle">
              <h2>
                DISCOVER HOW YOU CAN <span className="text-highlight">SAFELY BUILD</span>
              </h2>
              <h2>
                <span className="text-highlight">CONFIDENCE, STRENGTH AND ENERGY, DURING YOUR</span>
              </h2>
              <h2>
                <span className="text-highlight">PREGNANCY</span> - <span className="text-highlight">AND REBUILD EVEN STRONGER AFTER</span>
              </h2>
              <h2>- WITHOUT OVERWHELM OR INJURY RISK!</h2>
            </div>

            {/* Main Video Placeholder */}
            <div className="video-placeholder">
              {mainVideoUrl ? (
                <iframe
                  className="main-video-box"
                  src={mainVideoUrl}
                  title="Main Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              ) : (
                <div className="main-video-box" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, rgb(101, 170, 195) 0%, rgb(82, 139, 161) 100%)', color: 'white'}}>
                  <p>Loading video...</p>
                </div>
              )}
            </div>

            <div className="hero-description">
              <p>This Program Is Designed By Certified Pre/Postnatal Expert So You Can Feel Strong,</p>
              <p>Confident, And In Control Of Your Body Again — In Just 30 Days!</p>
            </div>

            {/* Countdown Timer */}
            <div className="countdown-section">
              <h3 className="countdown-title">NEXT PROGRAM STARTS IN !</h3>
              <div className="countdown-timer">
                <span className="timer-digit">{formatNumber(timeLeft.days)}</span>
                <span className="timer-separator">:</span>
                <span className="timer-digit">{formatNumber(timeLeft.hours)}</span>
                <span className="timer-separator">:</span>
                <span className="timer-digit">{formatNumber(timeLeft.minutes)}</span>
              </div>
            </div>

            <div className="spots-available">
              <h3>ONLY <span className="spots-number">{spotsLeft} SPOTS</span> AVAILABLE !</h3>
            </div>

            <div className="cta-section">
              <h3 className="cta-title">BOOK YOUR SPOT <span className="text-highlight">FOR FREE</span></h3>
              <div className="program-buttons">
                <Form type={'prenatal'} buttonComponent={(toggleModal) => (
                  <button
                    className="program-btn prenatal-btn"
                    onClick={toggleModal}
                  >
                    PRE - NATAL<br/>PROGRAM
                  </button>
                )} />
                <Form type={'postnatal'} buttonComponent={(toggleModal) => (
                  <button
                    className="program-btn postnatal-btn"
                    onClick={toggleModal}
                  >
                    POST - NATAL<br/>PROGRAM
                  </button>
                )} />
              </div>
            </div>
          </div>
        </div>

        {/* Dear Frustrated Mama Section */}
        <div className="mama-section">
          <div className="container">
            <h2 className="mama-title">DEAR FRUSTRATED MAMA</h2>

            <div className="mama-content">
              <p>
                If you've ever wanted to feel strong, light, and confident in your body again — without
                the constant back pain, heavy movement, or frustration of extra weight that just won't
                go away — this will be the most important message you'll ever read.
              </p>

              <p>
                Because I'm going to show you a safe, proven way to <strong>rebuild your strength, energy,
                and confidence</strong> — whether you're currently pregnant or have already given birth —
                <em> while being surrounded by a community of women who understand exactly what
                you're going through.</em>
              </p>

              <p>But before I do that, let me tell you a quick story...</p>

              <p>
                When I first started coaching new moms, I kept seeing the same heartbreaking pattern.
                They were exhausted, frustrated, and afraid to move. Most of them wanted to get active
                again — but every time they tried, they ended up feeling pain, weakness, or guilt for not
                "bouncing back."
              </p>

              <p className="quote">
                One mom told me, <em>"I don't even feel like myself anymore."</em><br/>
                That sentence hit me hard.
              </p>

              <br/>
              <div className="text-center">
                <h3 className="highlight-text">AFTER SEEING SO MANY WOMEN GO THROUGH</h3>
                <h3 className="highlight-text">THE SAME STRUGGLE, I DECIDED TO DO</h3>
                <h3 className="highlight-text">SOMETHING ABOUT IT.</h3>
              </div>
              <br/>

              <p>
                I spent years studying <strong>prenatal and postnatal training</strong>, learning how to help women
                move safely, heal properly, and regain their strength without risking injury. But I also
                realized — this journey isn't just physical. It's emotional.
              </p>

              <p>
                Every woman deserves a place where she feels seen, supported, and celebrated — by
                people who truly understand her.
              </p>

              <p>That's how the <strong>AOS Prenatal & Postnatal Program</strong> was born.</p>

              <br/>
              <div className="text-center">
                <h3 className="highlight-text">IT'S NOT JUST A WORKOUT PLAN — IT'S A</h3>
                <h3 className="highlight-text">SPACE WHERE WOMEN COME TOGETHER TO</h3>
                <h3 className="highlight-text">TRAIN, LEARN, AND GROW STRONGER —</h3>
                <h3 className="highlight-text">PHYSICALLY, MENTALLY, AND EMOTIONALLY.</h3>
              </div>
            </div>
          </div>
        </div>

        {/* Program Details Section */}
        <div className="program-details-section">
          <div className="container">
            <div className="cta-header">
              <h3 className="cta-title">BOOK YOUR SPOT <span className="text-highlight">FOR FREE</span></h3>
              <div className="program-buttons">
                <Form type={'prenatal'} buttonComponent={(toggleModal) => (
                  <button className="program-btn prenatal-btn" onClick={toggleModal}>PRE - NATAL<br/>PROGRAM</button>
                )} />
                <Form type={'postnatal'} buttonComponent={(toggleModal) => (
                  <button className="program-btn postnatal-btn" onClick={toggleModal}>POST - NATAL<br/>PROGRAM</button>
                )} />
              </div>

              <div className="countdown-timer-small">
                <span className="timer-digit">{formatNumber(timeLeft.days)}</span>
                <span className="timer-separator">:</span>
                <span className="timer-digit">{formatNumber(timeLeft.hours)}</span>
                <span className="timer-separator">:</span>
                <span className="timer-digit">{formatNumber(timeLeft.minutes)}</span>
              </div>
            </div>

            <p className="program-intro">
              When you join the <strong>AOS Prenatal & Postnatal Program</strong>, you're not just signing up
              for workouts — you're joining a complete system designed to <strong>guide you safely
              through every phase of your journey</strong>.
            </p>

            <p className="program-intro">
              You'll know exactly what to do, how to do it, and how to adjust your training as
              your body changes — before, during, and after pregnancy.
            </p>
            <br/>
            <h2 className="section-title">INSIDE THE 30 DAYS PRE OR POST - NATAL</h2>
            <h2 className="section-title">PROGRAM, YOU'LL GET</h2>

            <div className="program-features">
              <div className="feature">
                <h3>12 GROUP WORKOUT SESSIONS</h3>
                <p>
                  Whether you're preparing your body for birth or rebuilding strength after, you'll get
                  safe, low-impact movements designed by certified prenatal and postnatal
                  coaches — with a focus on posture, mobility, and core stability.
                </p>
              </div>

              <div className="feature">
                <h3>PERSONALIZED NUTRITION PLAN</h3>
                <p className="feature-subtitle">Because everybody — and every phase — is different.</p>
                <ul>
                  <li>Customized meal options to support hormonal balance and recovery</li>
                  <li>Easy, delicious recipes for steady energy and nourishment</li>
                  <li>Flexible approach — no food guilt, no starvation, and no "forbidden" foods</li>
                </ul>
              </div>

              <div className="feature">
                <h3>EDUCATIONAL WORKSHOPS</h3>
                <p className="feature-subtitle">Understand your body like never before.</p>
                <ul>
                  <li>Learn how pregnancy and postpartum affect strength, hormones, and movement</li>
                  <li>Discover the safest way to train and rebuild your core</li>
                  <li>Learn how to fuel your body for recovery, energy, and mental well-being</li>
                </ul>
              </div>

              <div className="feature">
                <h3>BEFORE & AFTER ASSESSMENTS</h3>
                <p className="feature-subtitle">Track your progress safely and confidently.</p>
                <ul>
                  <li>InBody measurements to monitor strength and body composition</li>
                  <li>Movement and posture assessments to ensure healthy progress</li>
                </ul>
              </div>

              <div className="feature">
                <h3>COACH & COMMUNITY SUPPORT</h3>
                <p className="feature-subtitle">You're never doing this alone.</p>
                <ul>
                  <li>Join a <strong>private WhatsApp group</strong> with coaches and other moms for daily motivation</li>
                  <li>Coaches are available <strong>24/7</strong> for guidance and accountability</li>
                  <li>A community that supports, listens, and celebrates every milestone with you</li>
                </ul>
              </div>

              <div className="feature bonus">
                <h3>💖 BONUS: THE MOTHERHOOD COMMUNITY EXPERIENCE</h3>
                <p>
                  Be part of a growing movement of women who choose <strong>strength over pressure</strong> and
                  <strong> support over isolation</strong>.
                </p>
                <p>You'll train, learn, laugh, and grow — surrounded by people who <em>truly get it</em>.</p>
              </div>
            </div>

            <div className="final-cta">
              <h3 className="cta-title">BOOK YOUR SPOT <span className="text-highlight">FOR FREE</span></h3>
              <div className="program-buttons">
                <Form type={'prenatal'} buttonComponent={(toggleModal) => (
                  <button className="program-btn prenatal-btn" onClick={toggleModal}>PRE - NATAL<br/>PROGRAM</button>
                )} />
                <Form type={'postnatal'} buttonComponent={(toggleModal) => (
                  <button className="program-btn postnatal-btn" onClick={toggleModal}>POST - NATAL<br/>PROGRAM</button>
                )} />
              </div>

              <div className="countdown-timer-small">
                <span className="timer-digit">{formatNumber(timeLeft.days)}</span>
                <span className="timer-separator">:</span>
                <span className="timer-digit">{formatNumber(timeLeft.hours)}</span>
                <span className="timer-separator">:</span>
                <span className="timer-digit">{formatNumber(timeLeft.minutes)}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Success Story Section */}
        <div className="success-section">
          <div className="container">
            <p className="success-text">
              This system was built over years of coaching, testing, and refining — and now it's
              available to you.
            </p>

            <p className="success-text">
              I'm incredibly proud of this program because every single mom who joins experiences
              transformation — physically, emotionally, and mentally.
            </p>

            <p className="success-text">You'll move easier.</p>
            <p className="success-text">You'll feel lighter.</p>
            <p className="success-text">You'll rebuild strength and confidence — safely and without pressure.</p>
            <br/>
            <h2 className="testimonial-title">BUT DON'T TAKE OUR WORD FOR IT.</h2>
            <h2 className="testimonial-title">HERE'S WHAT OUR MEMBERS HAVE TO SAY</h2>

            {/* Three Testimonial Image Placeholders */}
            <div className="image-placeholders">
              {testimonialVideo1 ? (
                <iframe
                  className="testimonial-box"
                  src={testimonialVideo1}
                  title="Testimonial 1"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              ) : (
                <div className="testimonial-box" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, rgb(101, 170, 195) 0%, rgb(82, 139, 161) 100%)', color: 'white'}}>
                  <p>Loading...</p>
                </div>
              )}
              {testimonialVideo2 ? (
                <iframe
                  className="testimonial-box"
                  src={testimonialVideo2}
                  title="Testimonial 2"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              ) : (
                <div className="testimonial-box" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, rgb(101, 170, 195) 0%, rgb(82, 139, 161) 100%)', color: 'white'}}>
                  <p>Loading...</p>
                </div>
              )}
              {testimonialVideo3 ? (
                <iframe
                  className="testimonial-box"
                  src={testimonialVideo3}
                  title="Testimonial 3"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              ) : (
                <div className="testimonial-box" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, rgb(101, 170, 195) 0%, rgb(82, 139, 161) 100%)', color: 'white'}}>
                  <p>Loading...</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Coach Section */}
        <div className="coach-section">
          <div className="container">
            <h2 className="coach-title">COACH MIRA GOT YOU COVERED</h2>

            <div className="coach-content">
              <div className="coach-image">
                <img src="/mira.jpeg" alt="Coach Mira" />
              </div>

              <div className="coach-bio">
                <p>
                  Led by Coach Mira, a Medical Doctor turned passionate fitness coach dedicated to
                  transforming individuals into their best selves. Drawing on years of experience and a deep
                  understanding of the challenges faced by women during and after pregnancy, she has
                  committed herself to guiding and empowering women through these transformative phases.
                  Certified by renowned institutions, she has already impacted numerous lives with her
                  expertise and support. Join Coach Mira on this journey to a healthier, stronger you.
                </p>
              </div>
            </div>

            <div className="final-cta">
              <h3 className="cta-title">BOOK YOUR SPOT <span className="text-highlight">FOR FREE</span></h3>
              <div className="program-buttons">
                <Form type={'prenatal'} buttonComponent={(toggleModal) => (
                  <button className="program-btn prenatal-btn" onClick={toggleModal}>PRE - NATAL<br/>PROGRAM</button>
                )} />
                <Form type={'postnatal'} buttonComponent={(toggleModal) => (
                  <button className="program-btn postnatal-btn" onClick={toggleModal}>POST - NATAL<br/>PROGRAM</button>
                )} />
              </div>

              <div className="countdown-timer-small">
                <span className="timer-digit">{formatNumber(timeLeft.days)}</span>
                <span className="timer-separator">:</span>
                <span className="timer-digit">{formatNumber(timeLeft.hours)}</span>
                <span className="timer-separator">:</span>
                <span className="timer-digit">{formatNumber(timeLeft.minutes)}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Final Section */}
        <div className="final-section">
          <div className="container">
            <h2 className="final-title">THE REASON YOU'RE FEELING THIS WAY RIGHT</h2>
            <h2 className="final-title">NOW — THE TIREDNESS, THE PAIN, THE</h2>
            <h2 className="final-title">HEAVINESS, THE FRUSTRATION OF NOT</h2>
            <h2 className="final-title">FEELING LIKE YOURSELF — IS THE EXACT</h2>
            <h2 className="final-title">REASON YOU NEED TO JOIN THIS PROGRAM.</h2>

            <p className="final-subtitle">Because if you're struggling with:</p>

            <ul className="struggle-list">
              <li>Constant back pain or pressure when you move</li>
              <li>Feeling drained, weak, or disconnected from your body</li>
              <li>Frustration from doing everything "right" but still not seeing progress</li>
              <li>Feeling alone in your journey — like no one really gets what you're going through</li>
            </ul>

            <p className="final-text">Then that's exactly <em>why</em> this program exists.</p>

            <p className="final-text">
              The fact that you don't have the energy, the motivation, or the guidance right now — is the very
              reason you need to be surrounded by a system and community that gives it back to you.
            </p>

            <p className="final-text">You've spent enough time putting yourself last.</p>
            <p className="final-text">Now it's time to take back control — safely, confidently, and with full support.</p>

            <p className="final-emphasis">
              Because the very reason you've been holding yourself back…<br/>
              is the same reason you <strong>need to start today.</strong>
            </p>
          </div>
        </div>

        <div className="final-cta-bottom">
          <h3 className="cta-title">BOOK YOUR SPOT <span className="text-highlight">FOR FREE</span></h3>
          <div className="program-buttons">
            <Form type={'prenatal'} buttonComponent={(toggleModal) => (
              <button className="program-btn prenatal-btn" onClick={toggleModal}>PRE - NATAL<br/>PROGRAM</button>
            )} />
            <Form type={'postnatal'} buttonComponent={(toggleModal) => (
              <button className="program-btn postnatal-btn" onClick={toggleModal}>POST - NATAL<br/>PROGRAM</button>
            )} />
          </div>

          <div className="countdown-timer-small">
            <span className="timer-digit">{formatNumber(timeLeft.days)}</span>
            <span className="timer-separator">:</span>
            <span className="timer-digit">{formatNumber(timeLeft.hours)}</span>
            <span className="timer-separator">:</span>
            <span className="timer-digit">{formatNumber(timeLeft.minutes)}</span>
          </div>
        </div>
      </div>

      <style jsx>{`
        .prenatal-container {
          box-sizing: border-box;
          text-size-adjust: 100%;
          -webkit-tap-highlight-color: transparent;
          -webkit-font-smoothing: antialiased;
          line-height: 1.5;
          font-family: Inter, sans-serif;
          font-weight: 400;
          user-select: none;
          font-size: 62.5%;
          display: flex;
          flex-direction: column;
          overflow-x: hidden;
          width: 100%;
        }

        .hero-section {
          background: white;
          padding: 40px 20px;
          text-align: center;
        }

        .hero-content {
          max-width: 1200px;
          margin: 0 auto;
        }

        .hero-title {
          margin-bottom: 30px;
        }

        .title-line1 {
          display: block;
          font-size: 28px;
          font-weight: 800;
          text-decoration: underline;
          margin-bottom: 15px;
          color: #000;
        }

        .title-line2 {
          display: block;
          font-size: 26px;
          font-weight: 800;
          line-height: 1.4;
          color: #000;
          font-family: 'Arial', sans-serif;
        }

        .title-line2:first-child {
          text-decoration: underline;
        }

        .hero-subtitle {
          font-family: 'Futura LT Condensed', 'Futura XBlk BT', 'Arial Black', sans-serif;
          margin: 40px auto;
          max-width: 1000px;
          font-size: 24px;
          font-weight: 900;
          line-height: 1.4;
          color: #000;
        }

        .hero-subtitle h2 {
          font-family: 'Futura LT Condensed', 'Futura XBlk BT', 'Arial Black', sans-serif;
          margin: 10px 0;
          font-size: 32px;
          font-weight: 900;
          text-transform: uppercase;
        }

        .text-highlight {
          font-family: 'Futura LT Condensed', 'Arial Black', sans-serif;
          color: rgb(228, 168, 155);
          font-weight: 900;
        }

        .video-placeholder {
          display: flex;
          justify-content: center;
          margin: 40px auto;
          max-width: 800px;
        }

        .main-video-box {
          height: 450px;
          width: 100%;
          border-radius: 15px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
        }

        .testimonial-box {
          height: 300px;
          width: 350px;
          border-radius: 15px;
          object-fit: cover;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
        }

        .hero-description {
          font-size: 20px;
          margin: 20px auto;
          max-width: 900px;
          line-height: 1.2;
          font-weight: 900;
          color: #333;
        }

        .hero-description p {
          margin: 5px 0;
        }

        .countdown-section {
          margin: 20px 0;
        }

        .countdown-title {
          font-size: 24px;
          font-weight: 700;
          color: rgb(228, 168, 155);
          margin-bottom: 20px;
          font-family: 'Futura LT Condensed', sans-serif;
        }

        .countdown-timer {
          font-size: 56px;
          font-weight: 800;
          color: #000;
          font-family: monospace;
        }

        .countdown-timer-small {
          font-size: 36px;
          font-weight: 700;
          color: #000;
          margin: 20px 0;
          font-family: monospace;
        }

        .timer-digit {
          padding: 0 5px;
        }

        .timer-separator {
          padding: 0 5px;
        }

        .spots-available {
          margin: 10px 0 0 0;
        }

        .spots-available h3 {
          font-family: 'Futura LT Condensed', sans-serif;
          font-size: 32px;
          font-weight: 700;
          margin: 0;
          padding: 0;
        }

        .spots-number {
          color: rgb(228, 168, 155);
          font-weight: 800;
        }

        .cta-section {
          margin: 0 0 20px 0;
        }

        .cta-title {
          font-size: 32px;
          font-weight: 800;
          margin: 0 0 30px 0;
          padding: 0;
          color: #000;
          font-family: 'Futura LT Condensed', sans-serif;
        }

        .program-buttons {
          display: flex;
          gap: 30px;
          justify-content: center;
          align-items: center;
        }

        .program-buttons-small {
          display: flex;
          gap: 20px;
          justify-content: center;
          align-items: center;
          margin: 20px 0;
        }

        .program-btn {
          padding: 25px 50px;
          font-size: 22px;
          font-weight: 900;
          font-family: 'Futura LT Condensed', 'Futura XBlk BT', 'Arial Black', sans-serif;
          color: white;
          border: none;
          border-radius: 10px;
          cursor: pointer;
          transition: all 0.3s;
          line-height: 1.4;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          text-transform: uppercase;
        }

        .program-btn-small {
          padding: 15px 30px;
          font-size: 16px;
          font-weight: 700;
          color: white;
          border: none;

          cursor: pointer;
          transition: transform 0.2s;
        }

        .prenatal-btn {
          background-color: rgb(217, 176, 166);
        }

        .postnatal-btn {
          background-color: rgb(217, 176, 166);
        }

        .program-btn:hover, .program-btn-small:hover {
          transform: scale(1.05);
        }

        .mama-section {
          background: rgb(255, 255, 255);
          padding: 0px 60px 20px;
        }

        .container {
          max-width: 900px;
          margin: 0 auto;
        }

        .mama-title {
          font-size: 42px;
          font-weight: 800;
          color: rgb(228, 168, 155);
          text-align: center;
          margin-bottom: 50px;
          font-family: 'Futura LT Condensed', sans-serif;
        }

        .mama-content {
          font-size: 18px;
          line-height: 1.8;
        }

        .mama-content p {
          margin-bottom: 20px;
        }

        .quote {
          text-align: center;
          font-size: 20px;
          margin: 30px 0;
          font-style: italic;
        }

        .highlight-text {
          font-size: 28px;
          font-weight: 800;
          color: rgb(228, 168, 155);
          line-height: 1.4;
          text-transform: uppercase;
          margin: 10px 0;
          font-family: 'Futura LT Condensed', sans-serif;
        }

        .text-center {
          text-align: center;
        }

        .image-placeholders {
          display: flex;
          gap: 20px;
          justify-content: center;
          align-items: center;
          margin: 40px auto;
          max-width: 1200px;
        }

        .program-details-section {
          background: white;
          padding: 0px 20px;
        }

        .cta-header {
          text-align: center;
          margin: 0 calc(-50vw + 50%) 40px;
          padding: 30px calc(50vw - 50%);
          background: rgb(251,245,246);
          border-radius: 0;
        }

        .program-intro {
          font-size: 18px;
          line-height: 1.6;
          margin-bottom: 20px;
          text-align: center;
        }

        .section-title {
          font-size: 32px;
          font-weight: 700;
          color: rgb(228, 168, 155);
          text-align: center;
          margin: 10px 0px 0px 30px;
          line-height: 1.3;
          text-transform: uppercase;
          font-family: 'Futura LT Condensed', sans-serif;
        }

        .program-features {
          margin: 40px 0;
        }

        .feature {
          margin-bottom: 50px;
          text-align: center;
          padding: 0 40px;
        }

        .feature h3 {
          font-size: 28px;
          font-weight: 900;
          margin-bottom: 20px;
          color: #000;
          text-transform: uppercase;
          text-align: center;
          font-family: 'Futura LT Condensed', 'Futura XBlk BT', sans-serif;
        }

        .feature p {
          font-size: 18px;
          line-height: 1.6;
          margin-bottom: 15px;
          text-align: center;
        }

        .feature-subtitle {
          font-style: italic;
          color: #333;
          font-size: 20px;
          margin-bottom: 20px;
        }

        .feature ul {
          list-style: none;
          padding: 0;
          max-width: 800px;
          margin: 0 auto;
          text-align: center;
        }

        .feature ul li {
          margin-bottom: 8px;
          position: relative;
          font-size: 18px;
          line-height: 1.6;
          text-align: center;
        }

        .feature ul li:before {
          content: "•";
          margin-right: 10px;
          color: #000;
          font-weight: bold;
          font-size: 20px;
        }

        .bonus {
          background: linear-gradient(135deg, #fff5f3 0%, #f0f8ff 100%);
          border: 2px solid rgb(228, 168, 155);

        }

        .success-section {
          background: rgb(255,255,255);
          padding: 0px 60px 20px;
          text-align: center;
        }

        .success-text {
          font-size: 18px;
          line-height: 1.6;
          margin-bottom: 15px;
        }

        .testimonial-title {
          font-size: 26px;
          font-weight: 700;
          color: rgb(228, 168, 155);
          font-family: 'Futura LT Condensed', sans-serif;
          margin: 0 0 10px 0;
          line-height: 1.3;
          text-transform: uppercase;
        }

        .testimonial-title:first-of-type {
          margin-top: 30px;
        }

        .coach-section {
          background: white;
          padding: 0px 60px 0px;
        }

        .coach-title {
          font-size: 32px;
          font-weight: 700;
          color: rgb(228, 168, 155);
          font-family: 'Futura LT Condensed', sans-serif;
          text-align: center;
          margin-bottom: 50px;
          text-transform: uppercase;
        }

        .coach-content {
          display: flex;
          gap: 40px;
          align-items: center;
        }

        .coach-image {
          flex: 1;
        }

        .coach-image img {
          width: 100%;
          border-radius: 10px;
        }

        .coach-bio {
          flex: 1;
        }

        .coach-bio p {
          font-size: 16px;
          line-height: 1.8;
        }

        .final-section {
          background: #rgb(255, 255, 255);
          padding: 0px 60px 20px;
        }

        .final-title {
          font-size: 26px;
          font-weight: 700;
          color: rgb(228, 168, 155);
          font-family: 'Futura LT Condensed', sans-serif;
          text-align: center;
          line-height: 1.2;
          text-transform: uppercase;
          margin: 0;
        }

        .final-subtitle {
          font-size: 20px;
          margin: 30px 0 20px;
          text-align: center;
        }

        .struggle-list {
          list-style: none;
          padding: 0;
          margin: 20px auto;
          max-width: 700px;
          text-align: center;
        }

        .struggle-list li {
          margin-bottom: 10px;
          font-size: 18px;
          line-height: 1.6;
          text-align: center;
        }

        .struggle-list li:before {
          content: "•";
          color: rgb(228, 168, 155);
          font-weight: bold;
          margin-right: 10px;
          font-size: 20px;
        }

        .final-text {
          font-size: 18px;
          line-height: 1.6;
          margin: 10px auto;
          text-align: center;
          max-width: 800px;
        }

        .final-emphasis {
          font-size: 20px;
          font-weight: 600;
          text-align: center;
          margin: 40px auto;
          max-width: 700px;
        }

        .final-cta {
          text-align: center;
          margin: 60px calc(-50vw + 50%);
          padding: 40px calc(50vw - 50%);
          background: rgb(251,245,246);
        }

        .final-cta-bottom {
          text-align: center;
          margin: 0 calc(-50vw + 50%);
          padding: 60px calc(50vw - 50%);
          background: rgb(251,245,246);
        }

        @media (max-width: 768px) {
          /* Hero Section */
          .hero-section {
            padding: 20px 15px;
          }

          .title-line1 {
            font-size: 18px;
          }

          .title-line2 {
            font-size: 16px;
            line-height: 1.3;
          }

          .hero-subtitle {
            font-size: 14px;
            font-family: 'Futura LT Condensed', sans-serif;
            margin: 20px auto;
          }

          .hero-subtitle h2 {
            font-family: 'Futura LT Condensed', sans-serif;
            font-size: 16px;
            margin: 5px 0;
          }

          .hero-description {
            font-size: 14px;
            margin: 15px auto;
          }

          .hero-description p {
            margin: 3px 0;
          }

          /* Countdown & Spots */
          .countdown-section {
            margin: 15px 0;
          }

          .countdown-title {
            font-size: 18px;
            margin-bottom: 10px;
          }

          .countdown-timer {
            font-size: 32px;
          }

          .countdown-timer-small {
            font-size: 24px;
          }

          .spots-available {
            margin: 8px 0 0 0;
          }

          .spots-available h3 {
            font-size: 20px;
          }

          /* CTA Section */
          .cta-section {
            margin: 0 0 15px 0;
          }

          .cta-title {
            font-size: 20px;
            margin-bottom: 20px;
            margin-top: 0;
          }

          /* Buttons */
          .program-buttons {
            flex-direction: column;
            gap: 12px;
          }

          .program-btn {
            padding: 12px 25px;
            font-size: 14px;
            width: 80%;
            max-width: 240px;
          }

          /* Mama Section */
          .mama-section {
            padding: 0px 15px 20px;
          }

          .mama-title {
            font-size: 20px;
            margin-bottom: 25px;
          }

          .mama-content {
            font-size: 14px;
            line-height: 1.6;
          }

          .mama-content p {
            margin-bottom: 15px;
          }

          .quote {
            font-size: 16px;
            margin: 20px 0;
          }

          .highlight-text {
            font-size: 14px;
            line-height: 1.2;
          }

          /* Program Details */
          .program-details-section {
            padding: 0px 15px;
          }

          .cta-header {
            margin: 0 -15px 30px -15px;
            padding: 20px 15px;
          }

          .program-intro {
            font-size: 14px;
            margin-bottom: 15px;
          }

          .section-title {
            font-size: 20px;
            margin: 8px 0;
          }

          /* Features */
          .feature {
            padding: 0 20px;
            margin-bottom: 35px;
          }

          .feature h3 {
            font-size: 18px;
            margin-bottom: 12px;
          }

          .feature p {
            font-size: 14px;
          }

          .feature-subtitle {
            font-size: 16px;
          }

          .feature ul li {
            font-size: 14px;
            margin-bottom: 8px;
          }

          /* Success Section */
          .success-section {
            padding: 0px 15px 20px;
          }

          .success-text {
            font-size: 14px;
            margin-bottom: 10px;
          }

          .testimonial-title {
            font-size: 18px;
          }

          /* Images/Videos */
          .image-placeholders {
            flex-direction: column;
            gap: 20px;
          }

          .testimonial-box {
            width: 90%;
            max-width: 350px;
            height: 200px;
          }

          .video-placeholder {
            padding: 0 15px;
          }

          .main-video-box {
            height: 200px;
          }

          /* Coach Section */
          .coach-section {
            padding: 0px 15px 0px;
          }

          .coach-title {
            font-size: 22px;
            margin-bottom: 30px;
          }

          .coach-content {
            flex-direction: column;
            gap: 20px;
          }

          .coach-bio p {
            font-size: 14px;
            line-height: 1.6;
          }

          /* Final Section */
          .final-section {
            padding: 0px 15px 20px;
          }

          .final-title {
            font-size: 14px;
            line-height: 1.15;
          }

          .final-subtitle {
            font-size: 16px;
            margin: 20px 0 15px;
          }

          .struggle-list li {
            font-size: 14px;
            margin-bottom: 8px;
          }

          .final-text {
            font-size: 14px;
            margin: 8px auto;
          }

          .final-emphasis {
            font-size: 16px;
            margin: 25px auto;
          }

          /* Final CTA */
          .final-cta {
            margin: 40px -15px;
            padding: 30px 15px;
          }

          .final-cta-bottom {
            margin: 0 -15px;
            padding: 40px 15px;
          }

          /* Container adjustments */
          .container {
            padding: 0 0px;
          }

          /* Bonus section */
          .bonus {
            padding: 20px;
          }
        }
      `}</style>
    </>
  );
};

export default PrenatalProgram;